 export enum TypeAlerte {
NC = 0,
FinPeriodeEssais = 1,
RappelRenouvellementVisiteMedicale = 2,
FinValiditeCarteSejour = 3,
ValidationEntreeSalarie = 4,
ClotureExercice = 5,
ClotureDSN = 6,
TauxPas = 7,
FinPrevisionnelleCDD = 8,
DpaeARealiser = 9,
IncoherenceEffectif = 10,
}


// WEBPACK FOOTER //
// ./src/dto/GenApi.iNotPaie.Dto/TypeAlerte.ts